var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-badge',{attrs:{"overlap":"","bordered":"","offset-y":"20","offset-x":"20","icon":"mdi-domino-mask","dot":"","color":"primary"}},[_c('v-btn',{attrs:{"data-cy":"mobile_menu_button","icon":""},on:{"click":_vm.toggleMainMenu}},[_c('hb-icon',[_vm._v("menu")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }